import React from 'react';
import styled, { css } from 'styled-components';
import { VOUCHER_EXTRA_TYPE } from '@/domainLogic/index.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { replacePlaceholdersWithValues } from '@/app/components/search/utils/translations.ts';
import { getVoucherExtraPromotionValues } from '@/app/components/search/components/EvolutionCard/utils/getPromotionsUtils.ts';
import { voucherExtraBannerSupported } from '@/app/components/search/utils/voucherExtra.ts';
import { useIconColorHex } from '@/app/common/icons/Icon';
import { starfishCssUrl } from '@/app/common/icons/starfish';
import { BaseBadgeContainer } from '../BaseBadge/styled';

// Also the size the glyph is requested at: it is a raster, fetched at twice this for retina.
const VOUCHER_ICON_SIZE = 24;

const biggerIcon = css`
  background-size: ${VOUCHER_ICON_SIZE}px ${VOUCHER_ICON_SIZE}px;
  padding-left: 0;
  padding-right: 30px;
  background-position: right;
`;

const iconToTheRight = css`
  padding-right: 30px;
  padding-left: 8px;
  background-position: right 8px center;
`;

const VoucherExtraStyled = styled(BaseBadgeContainer)`
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  font-size: ${({ theme }) => theme.kallisto.font.size['150']};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  line-height: 10px;
  text-align: right;
  display: block;
  ${iconToTheRight};
  ${biggerIcon};
`;

const VoucherExtraBadge = () => {
  const { t } = useTranslation();
  const brandHex = useIconColorHex('iconPrimaryDefault');
  const { localization } = usePageWrapperData();
  const { brand, country, currency } = localization;

  // TODO: only THIRTY is currently supported
  if (!voucherExtraBannerSupported(VOUCHER_EXTRA_TYPE.THIRTY, brand, country, currency)) return null;

  const { voucherCode, discountAmount } = getVoucherExtraPromotionValues(localization);
  const text = replacePlaceholdersWithValues(t('vacation.oss.cards.voucher_extra_label'), {
    discountAmount: `${discountAmount}</br>`,
    voucherCode: `<b>${voucherCode}</b>`,
  });

  return (
    <VoucherExtraStyled
      $icon={starfishCssUrl('Financial', 'icon-discount', brandHex, VOUCHER_ICON_SIZE)}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};

export default VoucherExtraBadge;
